import { OrganizationContact } from '@prisma/client'
import { DesignSystem } from '~/core/designSystem'
import { Toolbox } from '~/plugins/toolbox/shared'

const colors = [
  DesignSystem.ThemeConst.APPLE_RED,
  DesignSystem.ThemeConst.APPLE_ORANGE,
  DesignSystem.ThemeConst.APPLE_YELLOW,
  DesignSystem.ThemeConst.APPLE_GREEN,
  DesignSystem.ThemeConst.APPLE_CYAN,
  DesignSystem.ThemeConst.APPLE_BLUE,
  DesignSystem.ThemeConst.APPLE_INDIGO,
  DesignSystem.ThemeConst.APPLE_PURPLE,
]

export const getCustomerColor = (customer: OrganizationContact) => {
  const value = [customer.email, customer.firstname, customer.lastname]
    .filter(Boolean)
    .join(' ')

  const index = Toolbox.Utility.stringToRandomNumber(
    value,
    0,
    colors.length - 1,
  )

  return colors[index]
}
